import * as React from 'react'

import {
  getParentJoinUrl,
  getWhitelabelBranding,
} from 'main/components/common/AuthModal/ssoNavigation'
import Loader from 'main/components/common/Loader'
import { useWhitelabel } from 'main/framework'
import useSSOContext from 'main/hooks/useSSOContext'
import { Text } from 'main/ui'
import { activateGoogleOptimize } from 'main/util/googleOptimize'

import { IGoogleOptimize, ISSOTrackingProps } from '../../types'
import { ParentContainer, ParentSmallContainer } from './InitialParentSignUpForm.styles'

interface IProps extends ISSOTrackingProps {
  googleOptimize?: IGoogleOptimize
  subtext?: string
}

export default function InitialParentSignUpFormSSO(props: IProps) {
  const { googleOptimize, subtext } = props
  const { navContext } = useSSOContext() // this page doesn't set its own nav context but might pass along some
  const whitelabel = useWhitelabel()

  const extraContext = {
    networkId: props?.extraData?.networkId || whitelabel?.networkId,
    ...getWhitelabelBranding(whitelabel),
  }

  const parentJoinUrl = getParentJoinUrl(props, navContext, extraContext)

  React.useEffect(() => activateGoogleOptimize(), [JSON.stringify(googleOptimize)])

  React.useEffect(() => {
    window.location.replace(parentJoinUrl)
  })

  return (
    <>
      {subtext && (
        <ParentSmallContainer>
          <Text data-go={googleOptimize && googleOptimize.subtext}>{subtext}</Text>
        </ParentSmallContainer>
      )}

      <ParentContainer>
        <Loader />
      </ParentContainer>
    </>
  )
}
